$(function(){


/*!
 * This file was created by jetgraph Inc.
 * Copyright © 2025 jetgraph Inc. All rights reserved.
 * Unauthorized copying or redistribution is prohibited.
 */







/* .letterSpanを付与した行へのテキストアニメーション */

var classArray = [
"delay0","delay01","delay02","delay03","delay04","delay05","delay06","delay07","delay08","delay09",
"delay1","delay11","delay12","delay13","delay14","delay15","delay16","delay17","delay18","delay19",
"delay2","delay21","delay22","delay23","delay24","delay25","delay26","delay27","delay28","delay29",
"delay3","delay31","delay32","delay33","delay34","delay35","delay36","delay37","delay38","delay39",
"delay4","delay41","delay42","delay43","delay44","delay45","delay46","delay47","delay48","delay49",
"delay5","delay51","delay52","delay53","delay54","delay55","delay56","delay57","delay58","delay59",
];

var addclass = "dib slide-in-top easeInBack duration04 ";/*追加したいアニメーションのクラス + 半角空き*/


$(".letterSpan").each(function() {
var originalText = $.trim(this.textContent);
$(this).attr("aria-label", originalText);
var html = "";
var i = 10;
originalText.split("").forEach(function(v) {
var addclassThis = addclass + classArray[i];
html += "<span class='" + addclassThis + "' aria-hidden='true'>" + v + "</span>";
i++;
});
this.innerHTML = html;
});

/*2行目のとき*/
$(".letterSpan2").each(function() {
var text = $.trim(this.textContent),
html = "";
var i=20;
text.split("").forEach(function(v) {
var addclassThis = addclass;
addclassThis += classArray[i];
html += "<span  class='" + addclassThis + "'>" + v + "</span>";
i++;
});
this.innerHTML = html;
});


/*3行目のとき*/
$(".letterSpan3").each(function() {
var text = $.trim(this.textContent),
html = "";
var i=30;
text.split("").forEach(function(v) {
var addclassThis = addclass;
addclassThis += classArray[i];
html += "<span  class='" + addclassThis + "'>" + v + "</span>";
i++;
});
this.innerHTML = html;
});


/*4行目のとき*/
$(".letterSpan4").each(function() {
var text = $.trim(this.textContent),
html = "";
var i=40;
text.split("").forEach(function(v) {
var addclassThis = addclass;
addclassThis += classArray[i];
html += "<span  class='" + addclassThis + "'>" + v + "</span>";
i++;
});
this.innerHTML = html;
});


















});//ready






